import {svgIconWrapper} from '../svg-icon-wrapper';

import SignRequestRegular from './sign-request-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SignRequestRegular {...props} />;
}

SvgComponent.iconName = 'signRequestRegular';

export const SignRequestRegularIcon = svgIconWrapper(SvgComponent);
